var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCotranscatDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 340.343,
    height: 231.662,
    viewBox: "0 0 340.343 231.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_191",
    "data-name": "Rect\\xE1ngulo 191",
    width: 340.343,
    height: 231.662,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_cotranscat",
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54",
    "data-name": "Trazado 54",
    d: "M186.621,58.994l-45.227,64.173h86.787Z",
    transform: "translate(110.539 46.12)",
    fill: "#45783c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55",
    "data-name": "Trazado 55",
    d: "M228.893,125.5H142.106a1.624,1.624,0,0,1-1.326-2.559l45.225-64.173a1.541,1.541,0,0,1,1.359-.688,1.627,1.627,0,0,1,1.331.741L230.254,123a1.622,1.622,0,0,1-1.361,2.505m-83.656-3.246h80.67l-38.631-59.65Z",
    transform: "translate(109.827 45.406)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_188",
    "data-name": "Rect\\xE1ngulo 188",
    width: 20.168,
    height: 16.836,
    transform: "translate(285.243 169.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56",
    "data-name": "Trazado 56",
    d: "M180.969,114.336H160.8a1.621,1.621,0,0,1-1.623-1.623V95.877a1.622,1.622,0,0,1,1.623-1.623h20.168a1.623,1.623,0,0,1,1.623,1.623v16.836a1.622,1.622,0,0,1-1.623,1.623m-18.545-3.246h16.922V97.5H162.424Z",
    transform: "translate(124.442 73.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    "data-name": "Trazado 57",
    d: "M215.4,69.717s-9.88-10.085-37.893-10.7c-24.446,0-42.476,23.53-42.476,57.45,0,26.688,13.242,52.153,43.19,54.088,25.975,0,33.205-6.111,40.692-10.083,4.278-3.565,10.238,9.982,3.311,16.909-19,12.72-106.443,32.9-110.417-59.691,0-66.617,56.023-97.583,110.773-63.561,5.96,4.889-2.138,19.405-7.181,15.585",
    transform: "translate(87.411 31.424)",
    fill: "#ece452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58",
    "data-name": "Trazado 58",
    d: "M177.838,190.872c-10.945,0-22.354-1.939-32.655-7.159-21.356-10.819-32.89-32.762-34.283-65.217,0-32.544,13.164-58.49,36.118-71.252,22.5-12.512,50.619-10.236,77.135,6.242a1.913,1.913,0,0,1,.173.123c4.615,3.786,2.543,11.548-.725,15.694-2.7,3.417-5.94,4.351-8.467,2.439a1.542,1.542,0,0,1-.173-.151c-.105-.105-9.928-9.629-36.774-10.215-23.635,0-40.817,23.479-40.817,55.827,0,22.962,10.913,50.481,41.671,52.468,22.324,0,30.5-4.64,37.07-8.367.893-.506,1.757-1,2.623-1.459,1.81-1.393,4.111-1.039,5.907.928,3.409,3.733,4.928,13.012-.552,18.491a1.646,1.646,0,0,1-.244.2c-7.157,4.793-25.793,11.405-46.006,11.407m.49-148.356A60.626,60.626,0,0,0,148.6,50.083c-21.895,12.171-34.451,37.082-34.451,68.342,1.336,31.128,12.273,52.142,32.505,62.393,27.993,14.185,64.506,3.122,75.25-3.959,4.157-4.307,2.6-11.419.34-13.9-.943-1.035-1.352-.691-1.573-.508a1.724,1.724,0,0,1-.278.187c-.886.47-1.768.969-2.678,1.486-6.9,3.915-15.491,8.788-38.777,8.788-33.1-2.136-44.812-31.347-44.812-55.713,0-34.228,18.547-59.073,44.1-59.073,27.158.593,37.711,9.9,38.943,11.076,1.479,1,3.491-1.413,3.886-1.914,2.411-3.058,4.043-8.727,1.29-11.109C207.7,47.107,192.6,42.516,178.328,42.516",
    transform: "translate(86.699 30.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59",
    "data-name": "Trazado 59",
    d: "M150.28,61.717a1.627,1.627,0,0,1-1.589-1.3L144.719,41.17a1.624,1.624,0,1,1,3.181-.656l3.972,19.25a1.624,1.624,0,0,1-1.262,1.919,1.605,1.605,0,0,1-.33.034",
    transform: "translate(113.112 30.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    "data-name": "Trazado 60",
    d: "M145.128,62.284a1.623,1.623,0,0,1-1.468-.928l-8.251-17.419a1.624,1.624,0,0,1,2.935-1.39l8.251,17.419a1.623,1.623,0,0,1-.773,2.161,1.6,1.6,0,0,1-.693.157",
    transform: "translate(105.738 32.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61",
    "data-name": "Trazado 61",
    d: "M140.108,65.119a1.619,1.619,0,0,1-1.244-.579L126.03,49.261a1.623,1.623,0,1,1,2.486-2.088L141.35,62.451a1.624,1.624,0,0,1-1.242,2.667",
    transform: "translate(98.23 36.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    "data-name": "Trazado 62",
    d: "M138.209,68.767a1.6,1.6,0,0,1-.859-.248L120.238,57.825a1.623,1.623,0,1,1,1.719-2.753l17.114,10.694a1.624,1.624,0,0,1-.862,3",
    transform: "translate(93.403 42.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63",
    "data-name": "Trazado 63",
    d: "M137.651,72.184a1.635,1.635,0,0,1-.379-.045l-21.7-5.2a1.622,1.622,0,1,1,.755-3.156l21.7,5.192a1.624,1.624,0,0,1-.376,3.2",
    transform: "translate(89.38 49.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64",
    "data-name": "Trazado 64",
    d: "M135.288,78.33l-.094,0L113.8,77.106a1.624,1.624,0,0,1,.185-3.243l21.39,1.224a1.623,1.623,0,0,1-.091,3.243",
    transform: "translate(87.772 57.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_65",
    "data-name": "Trazado 65",
    d: "M112.522,87.152a1.623,1.623,0,0,1-.043-3.246l22.306-.611a1.624,1.624,0,1,1,.089,3.246l-22.308.611h-.045",
    transform: "translate(86.699 65.117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_66",
    "data-name": "Trazado 66",
    d: "M114.066,100.6a1.624,1.624,0,0,1-.506-3.166l21.39-7.029a1.624,1.624,0,0,1,1.014,3.086l-21.39,7.027a1.635,1.635,0,0,1-.508.082",
    transform: "translate(87.905 70.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_67",
    "data-name": "Trazado 67",
    d: "M117.326,111.911a1.623,1.623,0,0,1-.814-3.029l19.557-11.307a1.624,1.624,0,0,1,1.625,2.812l-19.557,11.307a1.633,1.633,0,0,1-.811.217",
    transform: "translate(90.452 76.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_68",
    "data-name": "Trazado 68",
    d: "M123.157,123.221a1.623,1.623,0,0,1-1.115-2.8l16.5-15.585a1.623,1.623,0,1,1,2.229,2.359l-16.5,15.585a1.612,1.612,0,0,1-1.114.444",
    transform: "translate(95.012 81.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69",
    "data-name": "Trazado 69",
    d: "M132.073,129.513a1.623,1.623,0,0,1-1.37-2.491l11-17.417a1.623,1.623,0,1,1,2.744,1.734l-11,17.417a1.62,1.62,0,0,1-1.374.757",
    transform: "translate(101.984 85.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_70",
    "data-name": "Trazado 70",
    d: "M143.224,133.346a1.8,1.8,0,0,1-.217-.014,1.623,1.623,0,0,1-1.393-1.825l2.445-18.335a1.623,1.623,0,1,1,3.218.429l-2.445,18.335a1.623,1.623,0,0,1-1.607,1.409",
    transform: "translate(110.699 87.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_71",
    "data-name": "Trazado 71",
    d: "M42.471,58.994,87.7,123.167H.911Z",
    transform: "translate(0.712 46.12)",
    fill: "#45783c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72",
    "data-name": "Trazado 72",
    d: "M88.41,125.5H1.625A1.622,1.622,0,0,1,.262,123L41.82,58.826a1.627,1.627,0,0,1,1.331-.741,1.554,1.554,0,0,1,1.359.688l45.227,64.173A1.624,1.624,0,0,1,88.41,125.5m-83.8-3.246h80.67L43.24,62.607Z",
    transform: "translate(0 45.407)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_189",
    "data-name": "Rect\\xE1ngulo 189",
    width: 20.168,
    height: 16.836,
    transform: "translate(34.932 169.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_73",
    "data-name": "Trazado 73",
    d: "M40.485,114.336H20.317a1.622,1.622,0,0,1-1.623-1.623V95.877a1.624,1.624,0,0,1,1.623-1.623H40.485a1.624,1.624,0,0,1,1.625,1.623v16.836a1.623,1.623,0,0,1-1.625,1.623M21.94,111.09H38.862V97.5H21.94Z",
    transform: "translate(14.615 73.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74",
    "data-name": "Trazado 74",
    d: "M25.449,69.717s9.88-10.085,37.893-10.7c24.446,0,42.476,23.53,42.476,57.45,0,26.688-13.242,52.153-43.19,54.088-25.975,0-33.205-6.111-40.692-10.083-4.278-3.565-10.238,9.982-3.311,16.909,19,12.72,106.444,32.9,110.417-59.691,0-66.617-56.023-97.583-110.773-63.561-5.96,4.889,2.138,19.405,7.181,15.585",
    transform: "translate(12.081 31.424)",
    fill: "#ece452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75",
    "data-name": "Trazado 75",
    d: "M64.437,190.871c-20.214,0-38.846-6.614-46-11.407a1.483,1.483,0,0,1-.244-.2,13.122,13.122,0,0,1-3.633-10.014,13.959,13.959,0,0,1,3.079-8.478c1.8-1.967,4.1-2.322,5.907-.928.868.463,1.732.953,2.623,1.459,6.571,3.727,14.748,8.364,37.175,8.364,30.654-1.983,41.567-29.5,41.567-52.465,0-32.348-17.182-55.827-40.853-55.827-26.823.586-36.642,10.119-36.739,10.215a1.776,1.776,0,0,1-.175.151c-2.527,1.912-5.769.978-8.465-2.439-3.27-4.146-5.342-11.908-.725-15.694a1.509,1.509,0,0,1,.173-.123C44.64,37.009,72.755,34.734,95.257,47.244c22.955,12.761,36.12,38.706,36.12,71.18-1.393,32.526-12.929,54.469-34.283,65.288-10.3,5.219-21.711,7.157-32.656,7.159M20.376,176.856C31.12,183.938,67.63,195,95.626,180.817c20.232-10.251,31.167-31.265,32.507-62.462,0-31.19-12.558-56.1-34.452-68.272-21.415-11.906-48.288-9.682-73.744,6.1-2.755,2.382-1.123,8.052,1.29,11.109.394.5,2.409,2.91,3.886,1.914,1.229-1.18,11.783-10.482,38.907-11.074,25.588,0,44.135,24.842,44.135,59.071,0,24.366-11.71,53.576-44.708,55.709h-.023c-23.375,0-31.958-4.871-38.859-8.784-.91-.517-1.792-1.016-2.676-1.486a1.74,1.74,0,0,1-.28-.187c-.219-.184-.629-.527-1.573.508-2.261,2.477-3.817,9.59.342,13.894M26.161,70.448h0Z",
    transform: "translate(11.368 30.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76",
    "data-name": "Trazado 76",
    d: "M43.9,61.717a1.6,1.6,0,0,1-.33-.034,1.624,1.624,0,0,1-1.261-1.919l3.972-19.25a1.624,1.624,0,1,1,3.18.656L45.49,60.422a1.627,1.627,0,0,1-1.589,1.3",
    transform: "translate(33.05 30.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77",
    "data-name": "Trazado 77",
    d: "M50.93,62.284a1.6,1.6,0,0,1-.693-.157,1.623,1.623,0,0,1-.773-2.161l8.251-17.419a1.624,1.624,0,0,1,2.935,1.39L52.4,61.356a1.623,1.623,0,0,1-1.468.928",
    transform: "translate(38.547 32.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78",
    "data-name": "Trazado 78",
    d: "M57.962,65.119a1.624,1.624,0,0,1-1.242-2.667L69.554,47.173a1.623,1.623,0,1,1,2.486,2.088L59.206,64.54a1.622,1.622,0,0,1-1.244.579",
    transform: "translate(44.045 36.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79",
    "data-name": "Trazado 79",
    d: "M61.737,68.766a1.624,1.624,0,0,1-.862-3L77.987,55.072a1.623,1.623,0,1,1,1.721,2.753L62.6,68.519a1.613,1.613,0,0,1-.859.248",
    transform: "translate(46.994 42.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80",
    "data-name": "Trazado 80",
    d: "M64.307,72.184a1.624,1.624,0,0,1-.376-3.2l21.7-5.192a1.622,1.622,0,1,1,.755,3.156l-21.7,5.2a1.635,1.635,0,0,1-.38.045",
    transform: "translate(49.006 49.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81",
    "data-name": "Trazado 81",
    d: "M66.537,78.33a1.623,1.623,0,0,1-.091-3.243l21.39-1.224a1.624,1.624,0,0,1,.185,3.243l-21.39,1.222-.094,0",
    transform: "translate(50.749 57.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82",
    "data-name": "Trazado 82",
    d: "M89.7,87.153h-.045l-22.308-.611a1.624,1.624,0,0,1,.087-3.246l22.308.611a1.624,1.624,0,0,1-.043,3.246",
    transform: "translate(51.419 65.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83",
    "data-name": "Trazado 83",
    d: "M87.758,100.6a1.635,1.635,0,0,1-.508-.082L65.86,93.492a1.624,1.624,0,0,1,1.014-3.086l21.39,7.029a1.624,1.624,0,0,1-.506,3.166",
    transform: "translate(50.615 70.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_84",
    "data-name": "Trazado 84",
    d: "M83.693,111.911a1.633,1.633,0,0,1-.811-.217L63.325,100.387a1.624,1.624,0,0,1,1.625-2.812l19.557,11.307a1.623,1.623,0,0,1-.814,3.029",
    transform: "translate(48.872 76.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85",
    "data-name": "Trazado 85",
    d: "M76.521,123.221a1.612,1.612,0,0,1-1.114-.444l-16.5-15.585a1.623,1.623,0,1,1,2.229-2.359l16.5,15.585a1.623,1.623,0,0,1-1.115,2.8",
    transform: "translate(45.654 81.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86",
    "data-name": "Trazado 86",
    d: "M65.192,129.513a1.62,1.62,0,0,1-1.374-.757l-11-17.417a1.623,1.623,0,1,1,2.744-1.734l11,17.417a1.623,1.623,0,0,1-1.37,2.491",
    transform: "translate(41.095 85.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_87",
    "data-name": "Trazado 87",
    d: "M50.286,133.346a1.623,1.623,0,0,1-1.607-1.409L46.234,113.6a1.623,1.623,0,1,1,3.218-.429L51.9,131.507a1.623,1.623,0,0,1-1.393,1.825,1.8,1.8,0,0,1-.217.014",
    transform: "translate(36.134 87.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_88",
    "data-name": "Trazado 88",
    d: "M85.742,35.9V192.356c0,4.791,4.679,7.758,10.593,8.98V35.9Z",
    transform: "translate(67.031 28.064)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_89",
    "data-name": "Trazado 89",
    d: "M97.049,203.672a1.585,1.585,0,0,1-.331-.034c-7.555-1.561-11.888-5.413-11.888-10.57V36.61a1.624,1.624,0,0,1,1.623-1.623h10.6a1.623,1.623,0,0,1,1.621,1.623V202.048a1.625,1.625,0,0,1-1.621,1.623M88.076,38.233V193.068c0,3.988,4.242,5.978,7.346,6.9V38.233Z",
    transform: "translate(66.318 27.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_90",
    "data-name": "Trazado 90",
    d: "M112.33,192.356V35.9h-16.3V201.953c8.3-.29,16.3-3.53,16.3-9.6",
    transform: "translate(75.076 28.064)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_91",
    "data-name": "Trazado 91",
    d: "M96.744,204.288a1.624,1.624,0,0,1-1.623-1.623V36.61a1.623,1.623,0,0,1,1.623-1.623h16.3a1.623,1.623,0,0,1,1.623,1.623V193.068c0,7.318-8.973,10.908-17.864,11.22h-.057M98.367,38.233V200.94c6.569-.57,13.052-3.15,13.052-7.872V38.233Z",
    transform: "translate(74.364 27.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_92",
    "data-name": "Trazado 92",
    d: "M91.687,35.9V201.336a33,33,0,0,0,7.742.617V35.9Z",
    transform: "translate(71.679 28.064)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_93",
    "data-name": "Trazado 93",
    d: "M98.921,204.31a34.32,34.32,0,0,1-6.849-.672,1.621,1.621,0,0,1-1.3-1.589V36.61A1.622,1.622,0,0,1,92.4,34.987h7.742a1.622,1.622,0,0,1,1.623,1.623V202.665a1.622,1.622,0,0,1-1.566,1.621q-.639.024-1.278.023m-4.9-3.617a31.762,31.762,0,0,0,4.494.367V38.233H94.022Z",
    transform: "translate(70.967 27.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_94",
    "data-name": "Trazado 94",
    d: "M30.307.911C117.085,19.8,202.736,21.132,287,.911l13.447,15.484c-91.543,26.21-186.5,23.769-283.989,0Z",
    transform: "translate(12.863 0.712)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95",
    "data-name": "Trazado 95",
    d: "M164.786,37.483q-1.7,0-3.4-.011c-46.031-.3-94.68-6.619-144.6-18.789a1.624,1.624,0,0,1-.825-2.66L29.809.542a1.62,1.62,0,0,1,1.556-.5c89.064,19.391,175.183,19.395,255.965.007a1.625,1.625,0,0,1,1.605.515L302.38,16.041a1.622,1.622,0,0,1-.779,2.625A496.764,496.764,0,0,1,164.786,37.483M20.185,16.166C68.937,27.86,116.433,33.936,161.4,34.226A494.3,494.3,0,0,0,298.253,16.241L287.128,3.432C206.419,22.638,120.467,22.63,31.6,3.41Z",
    transform: "translate(12.15 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_96",
    "data-name": "Trazado 96",
    d: "M22.1,10.933v7.334c90.359,20.7,178.5,22.784,263.737.408V11.341C200.607,33.717,112.462,31.63,22.1,10.933",
    transform: "translate(17.28 8.547)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97",
    "data-name": "Trazado 97",
    d: "M160.344,36.973q-1.874,0-3.749-.012c-42.834-.3-87.966-5.821-134.143-16.4a1.624,1.624,0,0,1-1.26-1.582V11.646a1.621,1.621,0,0,1,1.985-1.582c45.947,10.523,90.842,16.013,133.441,16.314a496.476,496.476,0,0,0,129.523-15.9,1.624,1.624,0,0,1,2.035,1.572v7.334a1.622,1.622,0,0,1-1.212,1.57,498.827,498.827,0,0,1-126.62,16.015M24.438,17.685c45.507,10.336,89.971,15.73,132.18,16.029a496.644,496.644,0,0,0,128.311-15.58v-3.98A500.11,500.11,0,0,1,156.595,29.626c-42.221-.3-86.673-5.664-132.156-15.947Z",
    transform: "translate(16.567 7.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98",
    "data-name": "Trazado 98",
    d: "M26.287,16.1v7.116c84.88,18.5,167.787,20.4,248.134.809v-6.8C194.886,36.059,111.768,34.511,26.287,16.1",
    transform: "translate(20.551 12.589)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_99",
    "data-name": "Trazado 99",
    d: "M157.164,40.163c-42.121,0-85.718-4.882-130.51-14.644a1.622,1.622,0,0,1-1.278-1.586V16.815a1.62,1.62,0,0,1,1.965-1.586C114.978,34.1,198.223,34.481,274.759,16.366a1.624,1.624,0,0,1,2,1.579v6.8a1.625,1.625,0,0,1-1.24,1.579A498.65,498.65,0,0,1,157.164,40.163M28.622,22.623c86.9,18.771,169.276,19.053,244.886.841V19.993C197.624,37.61,115.251,37.218,28.622,18.823Z",
    transform: "translate(19.838 11.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_100",
    "data-name": "Trazado 100",
    d: "M38.406,22.454v7.172c69.627,12.888,137.881,14.229,204.436,1.3v-6.94C176.822,36.416,108.45,35.245,38.406,22.454",
    transform: "translate(30.025 17.554)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_101",
    "data-name": "Trazado 101",
    d: "M147.735,42.258A598.652,598.652,0,0,1,38.822,31.936a1.623,1.623,0,0,1-1.327-1.6V23.167a1.621,1.621,0,0,1,1.915-1.6C110.812,34.609,179.4,35.124,243.253,23.1a1.624,1.624,0,0,1,1.924,1.6v6.938a1.623,1.623,0,0,1-1.315,1.595,503.6,503.6,0,0,1-96.127,9.026M40.741,28.988C111.319,41.9,178.993,42.338,241.929,30.3V26.652C178.8,38.274,111.136,37.756,40.741,25.11Z",
    transform: "translate(29.313 16.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_102",
    "data-name": "Trazado 102",
    d: "M56.414,30.144v5.2H201.871v-5.5c-44.539,6.528-93.638,5.63-145.457.306",
    transform: "translate(44.103 23.327)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_103",
    "data-name": "Trazado 103",
    d: "M202.584,37.673H57.126A1.623,1.623,0,0,1,55.5,36.05V30.856a1.624,1.624,0,0,1,1.789-1.616c56.577,5.812,104.026,5.716,145.056-.3a1.622,1.622,0,0,1,1.858,1.605v5.5a1.623,1.623,0,0,1-1.623,1.623M184.31,34.427H200.96v-2q-8.157,1.155-16.651,2m-125.56,0H78.417q-9.648-.764-19.667-1.775Z",
    transform: "translate(43.391 22.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104",
    "data-name": "Trazado 104",
    d: "M110.16,40.761c-13.445,0-26.078-2.111-33.793-5.648a1.623,1.623,0,0,1,.677-3.1h66.232a1.623,1.623,0,0,1,.677,3.1c-7.715,3.537-20.348,5.648-33.793,5.648m-22.7-5.5a107.816,107.816,0,0,0,22.7,2.254,107.816,107.816,0,0,0,22.7-2.254Z",
    transform: "translate(58.962 25.028)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_190",
    "data-name": "Rect\\xE1ngulo 190",
    width: 35.142,
    height: 17.723,
    transform: "translate(151.856 10.995)",
    fill: "#c5c5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105",
    "data-name": "Trazado 105",
    d: "M121.081,26.231H85.939a1.623,1.623,0,0,1-1.623-1.623V6.884a1.624,1.624,0,0,1,1.623-1.625h35.142A1.624,1.624,0,0,1,122.7,6.884V24.607a1.624,1.624,0,0,1-1.623,1.623M87.562,22.984h31.9V8.507h-31.9Z",
    transform: "translate(65.917 4.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_106",
    "data-name": "Trazado 106",
    d: "M121.076,7.287c0,2.7-8.141,4.889-18.183,4.889S84.712,9.988,84.712,7.287,92.853,2.4,102.893,2.4s18.183,2.188,18.183,4.889",
    transform: "translate(66.226 1.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107",
    "data-name": "Trazado 107",
    d: "M103.605,14.513c-7.355,0-19.8-1.372-19.8-6.514s12.449-6.512,19.8-6.512S123.414,2.858,123.414,8s-12.449,6.514-19.808,6.514M87.076,8c.686,1.181,6.744,3.266,16.53,3.266S119.453,9.18,120.139,8c-.686-1.18-6.744-3.266-16.533-3.266S87.762,6.819,87.076,8m33.1.075h0Z",
    transform: "translate(65.514 1.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108",
    "data-name": "Trazado 108",
    d: "M16.454,16.394l.257-.285,13.6-15.2L45.789,4.476l-12.223,16.2Z",
    transform: "translate(12.863 0.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    "data-name": "Trazado 109",
    d: "M34.279,23.008a1.643,1.643,0,0,1-.394-.048L16.772,18.682a1.624,1.624,0,0,1-.816-2.658L29.809.541a1.628,1.628,0,0,1,1.575-.5L46.866,3.606a1.624,1.624,0,0,1,.932,2.56l-12.223,16.2a1.627,1.627,0,0,1-1.3.645M20.17,16.184l13.461,3.366L43.7,6.209,31.589,3.421Z",
    transform: "translate(12.15 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    "data-name": "Trazado 110",
    d: "M159.317,4.782l10.7,15.89,18.743-4.278L175.308.911Z",
    transform: "translate(124.551 0.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    "data-name": "Trazado 111",
    d: "M170.725,23.009a1.624,1.624,0,0,1-1.347-.718L158.682,6.4a1.622,1.622,0,0,1,.964-2.484L175.639.045a1.619,1.619,0,0,1,1.607.515l13.445,15.482a1.625,1.625,0,0,1-.864,2.648l-18.743,4.278a1.652,1.652,0,0,1-.36.041M162.679,6.524l8.77,13.03,15.017-3.428L175.443,3.434Z",
    transform: "translate(123.839 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112",
    "data-name": "Trazado 112",
    d: "M43.38,41.44S82.189,12.105,93.8,8.743c0,0-13.139,18.946-50.421,32.7",
    transform: "translate(33.914 6.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_113",
    "data-name": "Trazado 113",
    d: "M83.855,52.023S144.3,12.268,162.39,7.714c0,0-20.467,25.674-78.535,44.309",
    transform: "translate(65.556 6.031)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCotranscatDisabled);
export default __webpack_public_path__ + "static/media/icon_cotranscat_disabled.5421650613114bb1be4db48bd12442a4.svg";
export { ForwardRef as ReactComponent };